// extracted by mini-css-extract-plugin
export var clickable = "Tag-module--clickable--09e24";
export var remove = "Tag-module--remove--5b44e";
export var removeTag = "Tag-module--removeTag--db0de";
export var tag = "Tag-module--tag--292fb";
export var tagContainer = "Tag-module--tagContainer--2597e";